import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useUserQuery } from "@/hooks/use-user";
import { useUserSettingsQuery } from "@/hooks/use-user-settings";
import { isAuthFreePath } from "@/lib/auth/auth-paths";
import { identifyUser } from "@/lib/posthog";
import { useAuthStore } from "@/stores/auth-store";

interface UserSettingsProviderProps {
  children: React.ReactNode;
}

export function UserSettingsProvider({ children }: UserSettingsProviderProps) {
  const { isAuthenticated } = useAuthStore();
  const { pathname } = useLocation();

  const enabled = isAuthenticated && !isAuthFreePath(pathname);
  useUserSettingsQuery({ enabled });

  const { data: user } = useUserQuery({ enabled });
  useEffect(() => {
    if (user) identifyUser(user);
  }, [user]);

  return <>{children}</>;
}
